import * as PIXI from 'pixi.js';
import GameConfig from '../../game/GameConfig';
import GameModel from '../../game/GameModel';
import {Cannon} from '../../common/map/MapState';
import GameUtils from 'src/game/GameUtils';
import {buildingTintForPlayerIndex} from '../player-colors';
import {Location} from '../../common/map/Location';

import Sprite = PIXI.Sprite;

export class CannonRenderer {
    private cannons: Map<string, Sprite> = new Map<string, Sprite>();

    public createCannon(cannon: Cannon): void {
        const key = new Location(cannon.x, cannon.y).toString();
        if (this.cannons.get(key)) {
            return;
        }
        this.cannons.set(key, this.createSprite(cannon));
    }

    public removeCannon(x: number, y: number): void {
        const key = new Location(x, y).toString();
        const sprite = this.cannons.get(key);
        if (sprite) {
            GameModel.cannonsContainer.removeChild(sprite);
            this.cannons.delete(key);
        }
    }

    public clear(): void {
        this.cannons.forEach(sprite => {
            GameModel.cannonsContainer.removeChild(sprite);
        });
        this.cannons.clear();
    }

    private createSprite(cannon: Cannon): Sprite {
        const texture = GameUtils.spriteTexture('cannons/cannon');
        const sprite = new Sprite(texture);
        sprite.position.set(cannon.x * GameConfig.tileSize, cannon.y * GameConfig.tileSize);
        sprite.tint = buildingTintForPlayerIndex(cannon.owner);
        GameModel.cannonsContainer.addChild(sprite);
        return sprite;
    }
}

export const cannonRenderer = new CannonRenderer();



// WEBPACK FOOTER //
// ./src/Pixi/map/CannonRenderer.ts